const styles = {
    headerContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        mb: '40px',
        alignItems: 'center',
        textAlign: 'center'
    },
    cardsContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: ['column', 'column', 'column', 'column', 'row'],
        justifyContent: 'center',
        gap: '20px',
        mb: '80px',
    },
    card: {
        width: ['auto', null, '95%', null, '380px'],
        height: ['434px', null, '500px', null, '434px'],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: "no-repeat",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    cardContent: {
        padding: '30px 30px 0',
    }
};

export default styles;
